import React from 'react';
import './LessonPrices.css';

// Lesson price list + accepted payment methods (SGD). Shown wherever a player or guest picks a session.
export const LESSON_PRICES = [
  { label: '1 person', length: '1 hour', price: 200 },
  { label: '2 people', length: '1 hour', price: 220 },
  { label: 'Any group', length: '90 minutes', price: 300 },
  { label: 'Any group', length: '120 minutes', price: 400 }
];

export default function LessonPrices({ compact = false }) {
  return (
    <section className={`lesson-prices${compact ? ' lesson-prices--compact' : ''}`} aria-label="Lesson prices">
      <h3 className="lesson-prices__title">💰 Lesson prices</h3>
      <ul className="lesson-prices__list">
        {LESSON_PRICES.map(p => (
          <li key={p.label + p.length} className="lesson-prices__row">
            <span className="lesson-prices__what">
              <strong>{p.length}</strong>
              <span className="lesson-prices__who">{p.label}</span>
            </span>
            <span className="lesson-prices__amount">{p.price} SGD</span>
          </li>
        ))}
      </ul>
      <p className="lesson-prices__note">90 and 120 minute lessons are a fixed price, however many people join.</p>
      <div className="lesson-prices__pay">
        <span className="lesson-prices__pay-label">Pay by</span>
        <span className="lesson-prices__chip">🎾 Playtomic</span>
        <span className="lesson-prices__chip">💳 Credit card on site</span>
        <span className="lesson-prices__chip">📱 QR code</span>
      </div>
    </section>
  );
}
